module.exports = __webpack_public_path__ + "static/img/tree.916b7905.svg";